<template>
  <div class="home-container">
    <el-row>
      <el-col :span="16">
        <el-card class="home-card" shadow="hover">
          <div slot="header" class="clearfix">
            <span>系统公告</span>
          </div>
          <div class="notice-content">
            <el-timeline>
              <el-timeline-item
                v-for="(item, index) in notices"
                :key="index"
                :timestamp="item.time"
              >
                {{ item.content }}
              </el-timeline-item>
            </el-timeline>
          </div>
        </el-card>

        <el-card class="home-card" shadow="hover">
          <div slot="header" class="clearfix">
            <span>最新帖子</span>
            <el-button
              style="float: right; padding: 3px 0"
              type="primary"
              size="small"
              @click="$router.push('/forum')"
            >
              查看全部
            </el-button>
          </div>
          <div class="post-list">
            <el-divider v-for="(post, index) in posts" :key="index" />
            <div v-for="(post, index) in posts" :key="index" class="post-item" @click="goToPostDetail(post.id)">
              <div class="post-title">{{ post.title }}</div>
              <div class="post-meta">
                <span>{{ post.username }}</span>
                <span>{{ formatDateTime(post.createTime) }}</span>
                <span>浏览 {{ post.viewCount }}</span>
                <span>回复 {{ post.replyCount }}</span>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card class="home-card" shadow="hover">
          <div slot="header" class="clearfix">
            <span>快速入口</span>
          </div>
          <div class="quick-entry">
            <el-row>
              <el-col :span="12">
                <div class="entry-item" @click="$router.push('/forum')">
                  <i class="el-icon-document"></i>
                  <span>论坛</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="entry-item" @click="$router.push('/match')">
                  <i class="el-icon-video-camera"></i>
                  <span>约战</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="entry-item" @click="$router.push('/rank')">
                  <i class="el-icon-medal"></i>
                  <span>排行榜</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="entry-item" @click="$router.push('/user')">
                  <i class="el-icon-user"></i>
                  <span>个人中心</span>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-card>

        <el-card class="home-card" shadow="hover">
          <div slot="header" class="clearfix">
            <span>热门英雄</span>
          </div>
          <div class="hot-heroes">
            <div v-for="(hero, index) in hotHeroes" :key="index" class="hero-item">
              <div class="hero-rank">{{ index + 1 }}</div>
              <div class="hero-name">{{ hero.name }}</div>
              <div class="hero-use-count">使用次数: {{ hero.useCount }}</div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {
      notices: [
        { time: '2024-01-01', content: '澄海3C电竞社区正式上线！' },
        { time: '2024-01-02', content: '新增1v1约战模式' },
        { time: '2024-01-03', content: '修复了论坛发帖bug' }
      ],
      posts: [
        { id: 1, title: '澄海3C最新版本更新内容', username: 'admin', createTime: '2024-01-01', viewCount: 100, replyCount: 20 },
        { id: 2, title: '1v1约战技巧分享', username: 'player1', createTime: '2024-01-02', viewCount: 80, replyCount: 15 },
        { id: 3, title: '如何提高APM？', username: 'player2', createTime: '2024-01-03', viewCount: 60, replyCount: 10 }
      ],
      hotHeroes: [
        { name: '剑圣', useCount: 1000 },
        { name: '恶魔猎手', useCount: 900 },
        { name: '光明游侠', useCount: 800 },
        { name: '黑暗游侠', useCount: 700 },
        { name: '牛头人酋长', useCount: 600 }
      ]
    }
  },
  created() {
    this.fetchPosts()
  },
  methods: {
    fetchPosts() {
      // 这里可以调用API获取最新帖子
      // this.$axios.get('/forum/post/list').then(res => {
      //   this.posts = res.data
      // })
    },
    goToPostDetail(id) {
      this.$router.push(`/forum/detail/${id}`)
    },
    formatDateTime(dateTimeStr) {
      if (!dateTimeStr) return ''
      const date = new Date(dateTimeStr)
      if (isNaN(date.getTime())) return ''
      
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    }
  }
}
</script>

<style scoped>
.home-container {
  padding: 20px 0;
}

.home-card {
  margin-bottom: 20px;
}

.notice-content {
  padding: 10px 0;
}

.post-list {
  padding: 10px 0;
}

.post-item {
  padding: 15px 0;
  cursor: pointer;
  transition: all 0.3s;
}

.post-item:hover {
  color: #1890ff;
}

.post-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
}

.post-meta {
  font-size: 14px;
  color: #999;
}

.post-meta span {
  margin-right: 15px;
}

.quick-entry {
  padding: 20px 0;
}

.entry-item {
  text-align: center;
  padding: 20px 0;
  cursor: pointer;
  transition: all 0.3s;
  border-radius: 4px;
}

.entry-item:hover {
  background-color: #f0f9ff;
  color: #1890ff;
}

.entry-item i {
  font-size: 32px;
  margin-bottom: 10px;
  display: block;
}

.hot-heroes {
  padding: 10px 0;
}

.hero-item {
  display: flex;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #f0f0f0;
}

.hero-item:last-child {
  border-bottom: none;
}

.hero-rank {
  font-size: 18px;
  font-weight: bold;
  width: 30px;
  text-align: center;
}

.hero-rank:nth-child(1) {
  color: #ff4d4f;
}

.hero-rank:nth-child(2) {
  color: #faad14;
}

.hero-rank:nth-child(3) {
  color: #13c2c2;
}

.hero-name {
  flex: 1;
  font-size: 14px;
}

.hero-use-count {
  font-size: 12px;
  color: #999;
}
</style>